// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ebe1f75e","977":"0893d96f"}[chunkId] + ".chunk.js";
};